export default {
    path: 'promotion',
    component: () => import('../Promotion.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách ưu đãi',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo ưu đãi',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa ưu đãi',
            component: () => import('../cu/CU.vue'),
        },
    ]
};